import { render, staticRenderFns } from "./PhoneBody.vue?vue&type=template&id=4315c786&"
import script from "./PhoneBody.vue?vue&type=script&lang=js&"
export * from "./PhoneBody.vue?vue&type=script&lang=js&"
import style0 from "../styles/phone-body.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports